import * as yup from "yup";
import "yup-phone";

// login validation

const ContactPopupValidation = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().email().required("Email is required"),
    phonenumber: yup
    .string()
    .phone()
    .required("Valid phone number is required")
    .label("Phone Number"),
});


export { ContactPopupValidation };